import {
    invoiceContract,
    InvoiceExportQueryParams,
} from "@common/contracts/invoice.contract";
import { getBackendAPIClient } from "./backendAPIClient";
import { XLSX_MIME } from "./fileDownload";

const invoiceBlobClient = getBackendAPIClient(invoiceContract, "blob", {
    jsonQuery: true,
});

export async function getInvoicesXlsx({
    workspaceId,
    filters,
    sort,
    groupBy,
    columns,
}: {
    workspaceId: string;
} & InvoiceExportQueryParams) {
    return await invoiceBlobClient.exportInvoicesXlsx({
        params: { workspaceId },
        query: {
            filters,
            sort,
            groupBy,
            columns,
        },
        extraHeaders: { Accept: XLSX_MIME },
    });
}
